import { render } from "./Footer.vue?vue&type=template&id=3a9e5fc2"
import script from "./Footer.js?vue&type=script&lang=js"
export * from "./Footer.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__